import React from 'react';
import Image from './image';
import Navbar from 'react-bootstrap/Navbar';
import Nav from 'react-bootstrap/Nav';
import NavDropdown from 'react-bootstrap/NavDropdown';
import WarningMessageHeader from './warningMessageHeader';
import Dropdown from 'react-bootstrap/Dropdown';
import { handleClick } from "../utils/event_handling";
import HelpZendesk from "./help.js";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { connect } from "react-redux";
import { browserHistory } from 'react-router';
import DropdownButton from 'react-bootstrap/DropdownButton';
import {
    //faBell,
    faUser, faChartPie, faHistory, faUserPlus, faServer,
    faUserCog, faUserFriends, faSignOutAlt,
    faShoppingBag, faExclamationTriangle, faArrowRight, faHdd,
    // faQuestion,
    //faHeadset,
    faBook, faDollarSign, faRocket, faUserMinus, faSearch
} from '@fortawesome/free-solid-svg-icons';
import { getApi } from "../utils/event_handling";
import $ from "jquery";
import { Link } from 'react-router';
// import OfflineComponent from './offlineComponent'
// import { Offline } from "react-detect-offline";
import ProgressLoader from './progressLoader';
import { get_document_link, getTrimmedNotificationMessage, getFeatureAccess, decryptForLocalUsage, canManageTeammates } from "../utils/common_utils";
import {
    IS_NONE_CHECK, REQUIRES_EXCLAMATION_TRIANGLE_ICON,
    LOCAL_STORE_KEY, QUALDO_DOCUMENTATION, PERMISSIONS_LOCAL_STORE_KEY
} from "../utils/constant";
// import InternetStatusAlert from './internetStatusAlert';
import NetworkStatusAlert from './NetworkStatusAlert';
import AiAssistant from './ai-assistant.js';
import { BookText, LogOut, Monitor, Moon, Palette, Sun, UserPen, Users } from 'lucide-react';
import { getBrandLogo } from "../utils/common_utils";


const deployed_domain = process.env.REACT_APP_DEPLOYMENT_DOMAIN

const colors = ['#FA4616', '#00c7d4', '#ffc700', '#4d9ff9', '#915cff', '#ff6c7c'];

const userToggle = React.forwardRef(({ children, onClick }, ref) => (
    <span
        href=""
        ref={ref}
        className="qd-header__topbar-icon dropdown-toggle"
        onClick={e => {
            e.preventDefault();
            onClick(e);
        }}
    >
        <FontAwesomeIcon color="#fff" icon={faUser} />
        {children}
    </span>

));

/*
const helpToggle = React.forwardRef(({ children, onClick }, ref) => (
    <div
    className="qd-header__topbar-icon"
    onClick={(e) => {
        e.preventDefault();
        onClick(e);
    }}
    >
        <span className="nav-link">
            <FontAwesomeIcon color="#fff" icon={faQuestion}/>
            {children}
        </span>
    </div>
  ));
  */

const customLink = React.forwardRef(({ link, tab, children, onClick }, ref) => (
    <Link to={link} className={link.includes(tab) ? "dropdown-item active" : "dropdown-item"}>
        {children}
    </Link>
));

const goToNotifications = () => {
    window.location.href = "/notification";
}
const bellToggle = React.forwardRef(({ children, onClick, unReadMsg }, ref) => {

    if (unReadMsg != null && unReadMsg.length > 0) {
        return (<span
            ref={ref}
            className="qd-header__topbar-icon"
            onClick={e => {
                e.preventDefault();
                onClick(e);
            }}
        >
            <svg width="24" height="25" viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M5.25 19.3845C5.0375 19.3845 4.85942 19.3127 4.71575 19.169C4.57192 19.0252 4.5 18.8469 4.5 18.6343C4.5 18.4218 4.57192 18.2437 4.71575 18.1C4.85942 17.9565 5.0375 17.8848 5.25 17.8848H6.30775V10.423C6.30775 9.07817 6.72283 7.88908 7.553 6.85575C8.383 5.82242 9.44867 5.1615 10.75 4.873V4.25C10.75 3.90283 10.8714 3.60767 11.1143 3.3645C11.3571 3.1215 11.6519 3 11.9988 3C12.3458 3 12.641 3.1215 12.8845 3.3645C13.1282 3.60767 13.25 3.90283 13.25 4.25V4.873C14.5513 5.1615 15.617 5.82242 16.447 6.85575C17.2772 7.88908 17.6923 9.07817 17.6923 10.423V17.8848H18.75C18.9625 17.8848 19.1406 17.9566 19.2843 18.1003C19.4281 18.2441 19.5 18.4223 19.5 18.635C19.5 18.8475 19.4281 19.0256 19.2843 19.1693C19.1406 19.3128 18.9625 19.3845 18.75 19.3845H5.25ZM11.9983 22.1923C11.5008 22.1923 11.0754 22.0153 10.7223 21.6613C10.3689 21.3073 10.1923 20.8817 10.1923 20.3845H13.8077C13.8077 20.8833 13.6306 21.3093 13.2762 21.6625C12.9219 22.0157 12.4959 22.1923 11.9983 22.1923ZM7.80775 17.8848H16.1923V10.423C16.1923 9.26533 15.783 8.27725 14.9645 7.45875C14.1458 6.64008 13.1577 6.23075 12 6.23075C10.8423 6.23075 9.85417 6.64008 9.0355 7.45875C8.217 8.27725 7.80775 9.26533 7.80775 10.423V17.8848Z" fill="white" />
            </svg>
            {children}
        </span>
        );
    } else {
        return (<span
            ref={ref}
            className="qd-header__topbar-icon"
            onClick={e => {
                e.preventDefault();
                goToNotifications();
            }}
        >
            <svg width="24" height="25" viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M5.25 19.3845C5.0375 19.3845 4.85942 19.3127 4.71575 19.169C4.57192 19.0252 4.5 18.8469 4.5 18.6343C4.5 18.4218 4.57192 18.2437 4.71575 18.1C4.85942 17.9565 5.0375 17.8848 5.25 17.8848H6.30775V10.423C6.30775 9.07817 6.72283 7.88908 7.553 6.85575C8.383 5.82242 9.44867 5.1615 10.75 4.873V4.25C10.75 3.90283 10.8714 3.60767 11.1143 3.3645C11.3571 3.1215 11.6519 3 11.9988 3C12.3458 3 12.641 3.1215 12.8845 3.3645C13.1282 3.60767 13.25 3.90283 13.25 4.25V4.873C14.5513 5.1615 15.617 5.82242 16.447 6.85575C17.2772 7.88908 17.6923 9.07817 17.6923 10.423V17.8848H18.75C18.9625 17.8848 19.1406 17.9566 19.2843 18.1003C19.4281 18.2441 19.5 18.4223 19.5 18.635C19.5 18.8475 19.4281 19.0256 19.2843 19.1693C19.1406 19.3128 18.9625 19.3845 18.75 19.3845H5.25ZM11.9983 22.1923C11.5008 22.1923 11.0754 22.0153 10.7223 21.6613C10.3689 21.3073 10.1923 20.8817 10.1923 20.3845H13.8077C13.8077 20.8833 13.6306 21.3093 13.2762 21.6625C12.9219 22.0157 12.4959 22.1923 11.9983 22.1923ZM7.80775 17.8848H16.1923V10.423C16.1923 9.26533 15.783 8.27725 14.9645 7.45875C14.1458 6.64008 13.1577 6.23075 12 6.23075C10.8423 6.23075 9.85417 6.64008 9.0355 7.45875C8.217 8.27725 7.80775 9.26533 7.80775 10.423V17.8848Z" fill="white" />
            </svg>
            {children}
        </span>
        );
    }
},
);
const envToggle = React.forwardRef(({ onClick, selectedEnv, latestEnvName }, ref) => (
    <div
        ref={ref}
        className="qd-env-dropdown__btn dropdown-toggle"
        onClick={(e) => {
            e.preventDefault();
            onClick(e);
        }}
    >
        <span className="env-tag" style={{ backgroundColor: selectedEnv?.color, }}>
            {selectedEnv?.label ? selectedEnv.label[0].toUpperCase() : latestEnvName?.[0]?.toUpperCase() || "E"}
        </span>
        {/* Add Loader when environment is loading */}
        {/* <span className="env-tag" style={{backgroundColor: 'rgba(0,0,0,0.5)'}}>
            <Image className="d-block" width="20px" src={"icon_preloader"} />
        </span> */}
        <span className="env-info">
            <label>Environment</label>
            <strong className="env-name">{selectedEnv ? selectedEnv.label : latestEnvName || "Select Environment"}</strong>
            {/* Skeleton Loader */}
            {/* <span className="env-name pt-1"><Skeleton width="80px" height="12px" /></span> */}
        </span>
    </div>
));

let activeItems = {
    'configure': 'nav-item',
    'profile': 'nav-item',
    'monitor': 'nav-item',
    'metrics': 'nav-item',
    'alerts': 'nav-item',
    'discover': 'nav-item',
    'incidents': 'nav-item',
    'realtime': 'nav-item'
};
let SUB_BRAND = process.env.REACT_APP_CUSTOM_SUB_BRAND
let BRAND_LOGO = getBrandLogo()
class NavigationHeader extends React.Component {
    constructor(props) {
        super(props);
        this.getApi = getApi.bind(this);
        this.handleHelp = this.handleHelp.bind(this);
        this.onKeyDownHandler = this.onKeyDownHandler.bind(this);
        this.check_access_billing = this.check_access_billing.bind(this);
        this.closeWarning = this.closeWarning.bind(this);

        // this.handleEnvSearchChange = this.handleSearchChange.bind(this);
        // this.handleSearchChange = this.handleSearchChange.bind(this);

        this.handleEnvSelect = this.handleEnvSelect.bind(this);
        this.handleEnvSearchChange = this.handleEnvSearchChange.bind(this);
        this.clearEnvSearch = this.clearEnvSearch.bind(this);
        let decrypt_data = decryptForLocalUsage(localStorage.getItem(LOCAL_STORE_KEY))
        let warning_message = decrypt_data['warning_message']
        // let warning_message = localStorage.getItem("warning_message");

        let showWarning = false;
        this.input = null;
        if (warning_message !== undefined && warning_message !== null && warning_message !== '' && warning_message !== 'undefined') {
            showWarning = true;
        }
        this.state = {
            unreadNotifications: null,
            featureAccess: getFeatureAccess(),
            selectedView: null,
            notificationLoaded: false,
            notificationType: null,
            selectedNotification: null,
            zendeskShow: false,
            showWarning: showWarning,
            warningMessage: warning_message,
            prefetch_load: this.props.prefetch_load === true ? this.props.prefetch_load : false,
            environment: [],
            //latest_env_name:this.props.selectedEnvName,
            // environment:
            // environment:this.props.environment,
            latest_env_name: this.props.latest_env_name,
            env_search_text: '',
            showAiAssistant: false,
            theme: localStorage.getItem("theme") || "light",
        }
        this.getNotificationHeaderData();
    }

    pageRefresh(internetstatus) {
        if (internetstatus === true) {
            window.location.reload(false);
        }
    }

    handleShowAiAssistant = () => {
        document.body.style.overflow = 'hidden';
        this.setState({ showAiAssistant: true });
    }

    handleHideAiAssistant = () => {
        document.body.style.overflow = 'auto';
        this.setState({ showAiAssistant: false });
    }

    handleEnvSearchChange = (event) => {
        let search_text = event.target.value.toLowerCase();
        this.setState({ env_search_text: search_text });

        let filteredEnv = this.state.environment.filter(env =>
            env.label.toLowerCase().includes(search_text)
        );

        this.setState({ filteredEnv: filteredEnv });
    };

    handleEnvSelect(env, index, latest_env_name) {
        this.props.callbackEnvironemnt(env)
        this.setState({
            selectedEnv: { ...env, color: colors[index % colors.length], },
        });
    }



    onKeyDownHandler = e => {
        if (e.keyCode === 13) {
            e.preventDefault();
            if (this.input.value.trim()) {
                let data = { "search_text": this.input.value }
                browserHistory.push({
                    pathname: '/discover',
                    state: data // your data array of objects
                })
            }
        }
    };

    componentDidMount() {
        if (this.props.cachenable === true || this.props.discoverCache === true) {   // Temp codition for avoid page break   need to remove later
            this.getApi("environments");
        }
        let header = $(".qd-header");
        let body = $("body");
        let shrinkIt = header.height();
        if (this.props.page === "realtime") {
        header.addClass("sticky-header");
        body.addClass("has-sticky-header");
        } else {
            // Scroll logic for other pages
            $(window).scroll(function () {
                let scroll = $(window).scrollTop();
                if (scroll >= shrinkIt) {
                    header.addClass("sticky-header");
                    body.addClass("has-sticky-header");
                } else {
                    header.removeClass("sticky-header");
                    body.removeClass("has-sticky-header");
                }
            });
        }
        $("#navBarToggler").click(function () {
            if ($("#navBarToggler").hasClass("collapsed")) {
                $("#navBarToggler").removeClass("collapsed");
                $("#navbarCollapse").addClass("show");
            } else {
                $("#navBarToggler").addClass("collapsed");
                $("#navbarCollapse").removeClass("show");
            }
        });

        //Start: Theme DOM Append
        document.documentElement.className = this.state.theme;
        if (this.state.theme === 'dark') {
            document.documentElement.classList.add('tw-dark');
        } else {
            document.documentElement.classList.remove('tw-dark');
        }
        //End: Theme DOM Append
    }

    /* Start: Theme Switching Code */

    toggleTheme = (newTheme) => {
        if (newTheme !== this.state.theme) {
            this.setState({ theme: newTheme });
        }
        this.setState({ themeSystem: '' });
    };

    setSystemTheme = () => {
        const prefersDarkMode = window.matchMedia('(prefers-color-scheme: dark)').matches;
        const newTheme = prefersDarkMode ? 'dark' : 'light';
        this.setState({ theme: newTheme, themeSystem: 'system' });
    };

    /* End: Theme Switching Code */

    static getDerivedStateFromProps(props, state) {
        const userNotificationDataFromProps = props.dataModule.userNotificationData;

        const currStateUnreads = state.unreadNotifications;
        const propsUnreadsCount = userNotificationDataFromProps.unreadNotifications.length;
        const unreadCountMisMatch = (currStateUnreads !== null) && (currStateUnreads.length !== propsUnreadsCount);

        const firstTimeLoading = state.notificationLoaded === false && userNotificationDataFromProps.loaded === true;

        if (firstTimeLoading || unreadCountMisMatch) {
            return {
                unreadNotifications: userNotificationDataFromProps.unreadNotifications,
                notificationLoaded: true
            };
        }

        return null;
    }

    goToTeamMate() {
        window.location.href = "/teammate";
    }

    getNotificationHeaderData() {
        let sessionToken = localStorage.getItem("sessionToken");
        if (sessionToken === "undefined" || sessionToken === "null" ||
            sessionToken === null || sessionToken === undefined) {
            window.location = '/';
            return;
        }

    }


    handleHelp() {
        //this.setState({zendeskShow:true});
        window.zE(function () {
            window.zE.show();
            window.zE.identify({
                name: localStorage.getItem('user_name'),
                email: localStorage.getItem('emailId'),
            });
        });
        window.zE.activate({ hideOnClose: false });
    }

    getErrorIcon(notification_type) {
        if (notification_type === "Data Quality Error") {
            return faServer;
        } else if (notification_type === "Model Error") {
            return faHdd;
        } else if (notification_type === "Limit Exceeded Alert") {
            return faExclamationTriangle;
        } else if (notification_type === "Payment Failure Alert") {
            return faDollarSign;
        } else if (notification_type === "Missing Dataset") {
            return faServer;
        } else if (notification_type === "Schema Drift") {
            return faServer;
        } else {
            if (REQUIRES_EXCLAMATION_TRIANGLE_ICON.includes(notification_type)) {
                return faExclamationTriangle;
            }
        }
    }

    /* getNotificationSendTimeInMinutes(createdTimeString){
        let minutes = null;
        let hours = null;
        let days = null;
        var currentTime = new Date();
        var createdTime = new Date(createdTimeString);
        minutes = parseInt((currentTime-createdTime)/(60*1000));
        hours = parseInt((currentTime-createdTime)/(3600*1000));
        days = parseInt((currentTime-createdTime)/(24*3600*1000));
        if(minutes != null && minutes <= 60){
            return minutes + " Mins ago";

        }else if(hours != null && hours <= 24){
            return hours + " Hours ago";

        }else{
            return days + " days ago"
        }
    }*/

    getNotificationSendTimeInMinutes(createdTimeString) {

        const createdUtc = new Date(createdTimeString.replace(" ", "T") + "Z");
        const nowLocal = new Date();
        const diffMs = nowLocal.getTime() - createdUtc.getTime();

        const minutes = Math.floor(diffMs / (60 * 1000));
        const hours = Math.floor(diffMs / (3600 * 1000));
        const days = Math.floor(diffMs / (24 * 3600 * 1000));
        if (minutes < 1) {
            return "Just now";
        } else if (minutes < 60) {
            return `${minutes} Mins ago`;
        } else if (hours < 24) {
            return `${hours} Hours ago`;
        } else if (hours < 48) {
            return `1 Day ago`;
        } else {
            return `${days} Days ago`;
        }

    }

    setView(evt, notificationType, selectedView) {
        window.location.href = "/notification?notification_id=" + evt;
    }


    renderNotifications() {
        let requests = [];
        if (this.state.unreadNotifications === undefined || this.state.unreadNotifications === null) {
            return requests;
        }


        requests = this.state.unreadNotifications.map(val => val.notification_type === "request" || val.notification_type === "request_auto_deleted" ?
            <Dropdown.Item key={val["notification_id"]}
                className="list-group-item settings-notification"
                eventKey={val["notification_id"]}
                onSelect={evt => { this.setView(evt, val.notification_type, val) }}>
                {
                    val.notification_type === "request" ?
                        <>
                            <div className="notification-icon">
                                <span>
                                    <i><FontAwesomeIcon color="#fff" icon={faUserPlus} /></i>
                                </span>
                            </div>
                            <div className="notification-content">
                                <div className="list-group-item-content">
                                    <h5 id={val["notification_id"]}>
                                        Invitation Request
                                    </h5>
                                    <small>{this.getNotificationSendTimeInMinutes(val["created_time"])}</small>
                                </div>
                                <p> {val["username"]} would like to join your team on Qualdo.</p>
                            </div>
                        </>
                        :
                        <>
                            <div className="notification-icon">
                                <span>
                                    <i><FontAwesomeIcon color="#fff" icon={faUserMinus} /></i>
                                </span>
                            </div>
                            <div className="notification-content">
                                <div className="list-group-item-content">
                                    <h5 id={val["notification_id"]}>
                                        Request Auto Deleted
                                    </h5>
                                    <small>{this.getNotificationSendTimeInMinutes(val["created_time"])}</small>
                                </div>
                                <p> {val["message"]}</p>
                            </div>
                        </>
                }
            </Dropdown.Item>
            :
            <Dropdown.Item className="list-group-item app-notification"
                key={val["notification_id"]}
                eventKey={val["notification_id"]}
                onSelect={evt => {
                    this.setView(evt, val.notification_type, val)
                }}>
                <div className="notification-icon">
                    <span>
                        <i>
                            <FontAwesomeIcon color="#fff"
                                icon={this.getErrorIcon(val.notification_type)} />
                        </i>
                    </span>
                </div>
                <div className="notification-content">
                    <div className="list-group-item-content">
                        <h5 id={val["notification_id"]}> {val["notification_type"]} </h5>
                        <small>{this.getNotificationSendTimeInMinutes(val["created_time"])}</small>
                    </div>
                    <p> {getTrimmedNotificationMessage(val)} </p>
                </div>
            </Dropdown.Item>
        );

        return requests;
    }

    closeWarning() {
        this.setState({ showWarning: false, warningMessage: null });
    }


    check_access_billing(isDrxFreeTrailExpired) {
        let permissions = decryptForLocalUsage(localStorage.getItem(PERMISSIONS_LOCAL_STORE_KEY))
        let permissionsList = [];
        if (permissions !== undefined && permissions !== null) {
            permissionsList = permissions;
        }
        let decrypt_data = decryptForLocalUsage(localStorage.getItem(LOCAL_STORE_KEY))
        let isPlanExpired = ((decrypt_data['isPlanExpired'] === true && decrypt_data['isInBufferPeriod'] === false) ? true : false);
        const showTeam = canManageTeammates() && !isDrxFreeTrailExpired;
        const teamLink = (
            <Dropdown.Item as={Link} to={this.state.prefetch_load !== true ? (isPlanExpired ? "/plan" : "/teammate") : ""}
                activeClassName="active">
                <i><Users size={16} color="currentColor" /></i>
                Team
            </Dropdown.Item>
        );
        // Non-SaaS (usage_payment false): billing menus hidden; Team still for Admin/DE
        if (this.state.featureAccess !== null && this.state.featureAccess["usage_payment"] === false) {
            return (
                <>
                    {showTeam ? teamLink : ''}
                </>
            );
        }

        return (
            <>
                {
                    permissionsList.includes('BillingAccess') && !isDrxFreeTrailExpired ?

                            <>
                                <Dropdown.Item to={this.state.prefetch_load !== true ? "/plan" : ""}
                                    as={Link}
                                    activeClassName="active" >
                                    <i><FontAwesomeIcon icon={faChartPie} /></i>
                                    Plan & Usage
                                </Dropdown.Item>
                                <Dropdown.Item to={this.state.prefetch_load !== true ? "/choose-plan" : ""}
                                    as={Link}
                                    activeClassName="active">
                                    <i><FontAwesomeIcon icon={faShoppingBag} /></i>
                                    Upgrade Plan
                                </Dropdown.Item>
                                <Dropdown.Item to={this.state.prefetch_load !== true ? "/billing" : ""}
                                    as={Link}
                                    activeClassName="active">
                                    <i><FontAwesomeIcon icon={faHistory} /></i>
                                    Billing & Payment
                                </Dropdown.Item>
                                {showTeam ? (
                                <Dropdown.Item as={Link} to={this.state.prefetch_load !== true ? isPlanExpired ? "/plan" : "/teammate" : ""}
                                    activeClassName="active">
                                    <i><FontAwesomeIcon icon={faUserFriends} /></i>
                                    Team
                                </Dropdown.Item>
                                ) : ''}
                            </> : (showTeam ? teamLink : '')
                }
            </>
        );
    }
    shouldComponentUpdate() {
        if (this.state.page === "configure") {
            if (this.state.prefetch_load === true) {
                return false;
            } else {
                return true;
            }
        } else {
            return true;
        }
    }

    componentDidUpdate(prevProps, prevState) {
        //Start: Theme DOM Append
        if (prevState.theme !== this.state.theme) {
            localStorage.setItem('theme', this.state.theme);
            document.documentElement.className = this.state.theme;
            if (this.state.theme === 'dark') {
                document.documentElement.classList.add('tw-dark');
            } else {
                document.documentElement.classList.remove('tw-dark');
            }
        }
        //End: Theme DOM Append

        if (prevProps.page === "configure") {
            if (prevProps.prefetch_load !== this.props.prefetch_load) {
                this.setState({ prefetch_load: this.props.prefetch_load });
            }
        }
    }

    clearEnvSearch() {
        this.setState({ env_search_text: '' });
    }
    getIntegrationStatus = (envLabel) => {
        if (!Array.isArray(this.props.envList)) {
            //   console.error("env_details is not an array:", this.props.envList);
            return false;
        }

        const env = this.props.envList.find(e => e.env_name === envLabel);
        return env ? env.is_integrations : false;
    };

    sortEnvironments = (envs) => {
        if (!envs || !Array.isArray(envs)) return envs;
        return [...envs].sort((a, b) => {
            const aIsSelected = a.label === this.props.selectedEnvName ? 1 : 0;
            const bIsSelected = b.label === this.props.selectedEnvName ? 1 : 0;
            if (aIsSelected !== bIsSelected) return bIsSelected - aIsSelected;

            const aActive = this.getIntegrationStatus(a.label) || (a.integration_ids && a.integration_ids.length > 0) ? 1 : 0;
            const bActive = this.getIntegrationStatus(b.label) || (b.integration_ids && b.integration_ids.length > 0) ? 1 : 0;
            if (aActive !== bActive) return bActive - aActive;

            const aLabel = a.label || "";
            const bLabel = b.label || "";
            return aLabel.toLowerCase().localeCompare(bLabel.toLowerCase());
        });
    };

    render() {
        // let {latest_env_name } = this.state;
        let selectedEnv = this.props.selectedEnv
        // const colors = ['#FA4616', '#00c7d4', '#ffc700', '#4d9ff9', '#915cff', '#ff6c7c'];
        // let permissions = decryptForLocalUsage(localStorage.getItem(PERMISSIONS_LOCAL_STORE_KEY))
        let decrypt_data = decryptForLocalUsage(localStorage.getItem(LOCAL_STORE_KEY))
        let isPlanExpired = ((decrypt_data['isPlanExpired'] === true && decrypt_data['isInBufferPeriod'] === false) ? true : false);
        // let isPlanExpired = ((localStorage.getItem("isPlanExpired") === "true" && localStorage.getItem("isInBufferPeriod") === "false") ? true : false);
        let hideCloseButton = false
        let isDrxFreeTrailExpired = false
        let isDrxFreeTrail = decrypt_data['is_drx_free_trail']
        let DrxFreeTrailStatus = decrypt_data['drx_free_trail_status']
        if (isDrxFreeTrail !== undefined && isDrxFreeTrail !== null && isDrxFreeTrail === true) {
            if (DrxFreeTrailStatus !== undefined && DrxFreeTrailStatus !== null && DrxFreeTrailStatus === "Expired") {
                hideCloseButton = true
                isDrxFreeTrailExpired = true
            }
        }

        for (let [key] of Object.entries(activeItems)) {
            activeItems[key] = "nav-item";
        }
        activeItems[this.props.page] = 'nav-item active'
        let incidentBadge = null;
        if (this.props.page === 'incidents' || this.props.page === 'incident-management') {
            incidentBadge = 'Data';
        } else if (this.props.page === 'vertical-incidents') {
            incidentBadge = 'Business';
            activeItems['incidents'] = 'nav-item active';
        }

        let warning_message;
        if (this.state.warningMessage !== null) {
            warning_message = this.state.warningMessage;
        }

        let notificationAlertClassName = "";
        let notificationCircleCount = "";

        const currUnreadNotifications = this.state.unreadNotifications;
        const unreadCount = IS_NONE_CHECK.includes(currUnreadNotifications) ? '' : currUnreadNotifications.length;

        if (unreadCount > 0) {
            notificationAlertClassName = "badge alert-badge";
            notificationCircleCount = unreadCount;
        }

        let hideProfileModelTab = true;
        let enableDiscoveryTab = false;
        let enablePowerBiTab = false;
        if (!IS_NONE_CHECK.includes(this.state.featureAccess)) {
            const profileModel = this.state.featureAccess["models"];
            const discoverTab = this.state.featureAccess["discover"];
            hideProfileModelTab = profileModel === false;
            enableDiscoveryTab = discoverTab === true;
            const powerbiTab = this.state.featureAccess["powerbi"];
            enablePowerBiTab = powerbiTab === true;
        }

        return (
            <>
                {
                    this.state.showWarning === true ?
                        <WarningMessageHeader warning_message={warning_message} closeWarning={this.closeWarning} hideCloseButton={hideCloseButton} />
                        : ''
                }


                <header className={this.props.page==="realtime" ? "qd-header sticky-header" : "qd-header"}>
                    <div className="qd-header-container navbar navbar-expand-md">
                        {(SUB_BRAND !== null && SUB_BRAND !== undefined) ?
                            <dt className="title-text"><small >{SUB_BRAND}</small></dt>
                            :
                            ''
                        }
                        <Navbar expand="lg">
                            <Navbar.Brand href={isDrxFreeTrailExpired ? "/discover" : isPlanExpired ? "/plan" : "/configure"}>
                                <div className="qd-header__brand">
                                    <Image
                                        className="qd-header__brand-logo-default"
                                        src={BRAND_LOGO}
                                    />
                                </div>
                            </Navbar.Brand>
                            <Navbar.Toggle aria-controls="basic-navbar-nav" />
                            <Navbar.Collapse id="basic-navbar-nav">
                                <Nav className="mr-auto">
                                    <Nav.Item className={activeItems['configure']}>
                                        <Link to={isPlanExpired ? "/plan" : (isDrxFreeTrailExpired ? "/discover" : "/configure")} className={`nav-link${isPlanExpired || isDrxFreeTrailExpired ? " disabled" : ""}`}>
                                            Configure
                                        </Link>
                                    </Nav.Item>
                                    {this.state.prefetch_load === true ?
                                        <Nav.Item className={activeItems['monitor']}>
                                            <Link className="nav-link cursor-progress">
                                                Profile
                                            </Link>
                                        </Nav.Item>
                                        :
                                        <NavDropdown title="Profile" className={activeItems['profile']}
                                            id="basic-nav-dropdown">
                                            <NavDropdown.Item className={activeItems['data_profile']}
                                                as={customLink}
                                                link={isPlanExpired ? "/plan" : (isDrxFreeTrailExpired ? "/discover" : "/data-profile")}
                                                tab={this.props.tab}>
                                                <i>
                                                    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                        <path d="M19.2 14.294C18.8425 14.4792 18.4438 14.646 18.0126 14.7912C16.3765 15.3421 14.2141 15.6364 12 15.6364C9.78589 15.6364 7.62352 15.3421 5.9874 14.7912C5.55624 14.646 5.15753 14.4792 4.8 14.294V18.3654C4.80021 18.3667 4.80058 18.3694 4.80176 18.3734C4.80445 18.3825 4.812 18.4015 4.829 18.4302C4.8648 18.4905 4.93939 18.5839 5.08125 18.6992C5.37025 18.934 5.85327 19.1929 6.55693 19.4299C7.9589 19.9019 9.91761 20.1818 12 20.1818C14.0824 20.1818 16.0411 19.9019 17.4431 19.4299C18.1467 19.1929 18.6297 18.934 18.9187 18.6992C19.0606 18.5839 19.1352 18.4905 19.171 18.4302C19.188 18.4015 19.1956 18.3825 19.1982 18.3734C19.1994 18.3694 19.1998 18.3667 19.2 18.3654V14.294ZM19.2 7.93129C18.8388 8.11793 18.4386 8.2841 18.0126 8.42756C16.4326 8.95956 14.3066 9.27273 12 9.27273C9.69343 9.27273 7.56744 8.95956 5.9874 8.42756C5.56136 8.2841 5.16123 8.11793 4.8 7.93129V12.0018C4.80021 12.0031 4.80058 12.0057 4.80176 12.0098C4.80445 12.0189 4.812 12.0379 4.829 12.0666C4.8648 12.1269 4.93939 12.2203 5.08125 12.3356C5.37025 12.5704 5.85327 12.8293 6.55693 13.0662C7.9589 13.5383 9.91761 13.8182 12 13.8182C14.0824 13.8182 16.0411 13.5383 17.4431 13.0662C18.1467 12.8293 18.6297 12.5704 18.9187 12.3356C19.0606 12.2203 19.1352 12.1269 19.171 12.0666C19.188 12.0379 19.1956 12.0189 19.1982 12.0098C19.1994 12.0057 19.1998 12.0031 19.2 12.0018V7.93129ZM19.1974 5.62216C19.1943 5.61198 19.1863 5.5923 19.1684 5.56268C19.1302 5.49986 19.0522 5.40533 18.9064 5.28924C18.6093 5.05269 18.1235 4.79925 17.4431 4.57014C16.0915 4.11506 14.1669 3.81818 12 3.81818C9.83306 3.81818 7.90851 4.11506 6.55693 4.57014C5.87646 4.79925 5.39071 5.05269 5.09355 5.28924C4.94777 5.40533 4.86982 5.49986 4.83164 5.56268C4.81366 5.5923 4.80573 5.61198 4.80264 5.62216C4.7998 5.63157 4.8 5.6357 4.8 5.63636C4.8 5.63703 4.7998 5.64116 4.80264 5.65057C4.80573 5.66075 4.81366 5.68043 4.83164 5.71005C4.86982 5.77287 4.94777 5.8674 5.09355 5.98349C5.39071 6.22004 5.87646 6.47347 6.55693 6.70259C7.90851 7.15767 9.83306 7.45455 12 7.45455C14.1669 7.45455 16.0915 7.15767 17.4431 6.70259C18.1235 6.47347 18.6093 6.22004 18.9064 5.98349C19.0522 5.8674 19.1302 5.77287 19.1684 5.71005C19.1863 5.68043 19.1943 5.66075 19.1974 5.65057C19.2002 5.64116 19.2 5.63703 19.2 5.63636C19.2 5.6357 19.2002 5.63157 19.1974 5.62216ZM21 18.3636C21 19.1139 20.5564 19.7013 20.0473 20.1152C19.5299 20.5358 18.8275 20.8804 18.0126 21.1548C16.3765 21.7057 14.2141 22 12 22C9.78589 22 7.62352 21.7057 5.9874 21.1548C5.17248 20.8804 4.47015 20.5358 3.95273 20.1152C3.44356 19.7013 3 19.1139 3 18.3636V5.63636C3 4.86198 3.46673 4.26873 3.9791 3.8608C4.50164 3.44483 5.20221 3.10957 5.9874 2.84517C7.56744 2.31317 9.69343 2 12 2C14.3066 2 16.4326 2.31317 18.0126 2.84517C18.7978 3.10957 19.4984 3.44483 20.0209 3.8608C20.5333 4.26873 21 4.86198 21 5.63636V18.3636Z" fill="currentColor" />
                                                    </svg>
                                                </i> Data
                                            </NavDropdown.Item>
                                            {hideProfileModelTab ? "" : <NavDropdown.Item className={activeItems['ml-profile']}
                                                as={customLink}
                                                link={isPlanExpired ? "/plan" : (isDrxFreeTrailExpired ? "/discover" : "/ml-profile")}
                                                tab={this.props.tab}>
                                                <i>
                                                    <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none">
                                                        <path d="M12 2C12.4724 2 12.9361 2.12611 13.3456 2.36402L13.3465 2.36314L19.6465 5.99982L19.65 6.00249C20.06 6.24163 20.401 6.58551 20.6379 6.99956C20.8747 7.41357 20.9995 7.88338 21 8.36154V15.6367C20.9995 16.1149 20.8747 16.5846 20.6379 16.9987C20.401 17.4127 20.06 17.7566 19.65 17.9957L19.6465 17.9984L13.3465 21.6351L13.3456 21.6342C12.9641 21.8558 12.5356 21.9788 12.0967 21.9947C12.0649 21.9981 12.0327 22 12 22C11.967 22 11.9345 21.9982 11.9024 21.9947C11.4636 21.9786 11.0349 21.8559 10.6535 21.6342V21.6351L4.35352 17.9984L4.35 17.9957C3.93999 17.7566 3.59904 17.4127 3.36211 16.9987C3.12526 16.5846 3.00049 16.1149 3 15.6367V8.36154L3.00615 8.18219C3.03368 7.76645 3.15497 7.3617 3.36211 6.99956C3.59903 6.58551 3.94003 6.24163 4.35 6.00249L4.35352 5.99982L10.6535 2.36314V2.36402C11.0632 2.12586 11.5273 2 12 2ZM4.8 15.6349L4.80791 15.7539C4.82341 15.8714 4.86134 15.9853 4.92041 16.0886C4.99869 16.2254 5.11142 16.3393 5.24648 16.4189L11.1 19.7972V12.5247L4.8 8.86762V15.6349ZM12.9 12.5247V19.7972L18.7535 16.4189C18.8886 16.3393 19.0013 16.2254 19.0796 16.0886C19.1583 15.951 19.1997 15.7947 19.2 15.6358V8.86762L12.9 12.5247ZM12 3.81834C11.842 3.81834 11.6868 3.86021 11.55 3.93998L11.5465 3.94176L5.72021 7.30409L12 10.9497L18.2789 7.30409L12.4535 3.94176L12.45 3.93998C12.3132 3.86021 12.158 3.81834 12 3.81834Z" fill="currentColor" />
                                                    </svg>
                                                </i> Models
                                            </NavDropdown.Item>
                                            }
                                        </NavDropdown>}

                                    <Nav.Item className={activeItems['realtime']}>
                                        <Link to={isPlanExpired ? "/plan" : "/realtime"}
                                            className="nav-link">
                                            Monitor
                                        </Link>
                                    </Nav.Item>

                                    {/* <Nav.Item className={activeItems['monitor']}>
                                    {this.state.prefetch_load === true ?
                                    <Link className="nav-link cursor-progress">
                                        Monitor
                                    </Link>
                                     :
                                     <Link to={isPlanExpired ? "/plan" : (isDrxFreeTrailExpired ? "/discover": "/monitor")} className={`nav-link${isPlanExpired  || isDrxFreeTrailExpired ? " disabled" : ""}`}>
                                        Monitor
                                    </Link>
                                }
                                </Nav.Item> */}

                                  {/* <Nav.Item className={activeItems['realtime']}>
                                    <Link
                                      to={
                                        isPlanExpired
                                          ? "/plan"
                                          : (isDrxFreeTrailExpired ? "/discover" :"/realtime")
                                      }
                                      className={`nav-link${isPlanExpired || isDrxFreeTrailExpired ? " disabled" : ""}`}
                                    >
                                      Monitor
                                    </Link>
                                </Nav.Item> */}

                                <Nav.Item className={activeItems['metrics']}>
                                {this.state.prefetch_load === true ?
                                <Link disabled className="nav-link cursor-progress">
                                        Metrics
                                    </Link>
                                    :
                                    <Link to={isPlanExpired ? "/plan" : (isDrxFreeTrailExpired ? "/discover": "/metrics")} className={`nav-link${isPlanExpired  || isDrxFreeTrailExpired ? " disabled" : ""}`}>
                                        Metrics
                                    </Link>
                                }
                                </Nav.Item>
                                <Nav.Item className={activeItems['alerts']}>
                                {this.state.prefetch_load === true ?
                                    <Link className="nav-link cursor-progress">
                                        Alerts
                                    </Link>
                                    :
                                    <Link to={isPlanExpired ? "/plan" : (isDrxFreeTrailExpired ? "/discover": "/alerts")} className={`nav-link${isPlanExpired  || isDrxFreeTrailExpired ? " disabled" : ""}`}>
                                        Alerts
                                     </Link>
                                }
                                </Nav.Item>
                                { enableDiscoveryTab?
                                <Nav.Item className={activeItems['discover']}>
                                    {/* {this.state.prefetch_load === true ?
                                    <Nav.Item className={activeItems['metrics']}>
                                        {this.state.prefetch_load === true ?
                                            <Link disabled className="nav-link cursor-progress">
                                                Metrics
                                            </Link>
                                            :
                                            <Link to={isPlanExpired ? "/plan" : (isDrxFreeTrailExpired ? "/discover" : "/metrics")} className={`nav-link${isPlanExpired || isDrxFreeTrailExpired ? " disabled" : ""}`}>
                                                Metrics
                                            </Link>
                                        }
                                    </Nav.Item>
                                    <Nav.Item className={activeItems['alerts']}>
                                        {this.state.prefetch_load === true ?
                                            <Link className="nav-link cursor-progress">
                                                Alerts
                                            </Link>
                                            :
                                            <Link to={isPlanExpired ? "/plan" : (isDrxFreeTrailExpired ? "/discover" : "/alerts")} className={`nav-link${isPlanExpired || isDrxFreeTrailExpired ? " disabled" : ""}`}>
                                                Alerts
                                            </Link>
                                        }
                                    </Nav.Item>
                                    {enableDiscoveryTab ?
                                        <Nav.Item className={activeItems['discover']}>
                                            {/* {this.state.prefetch_load === true ?
                                    <Link className="nav-link cursor-progress">
                                        Discover
                                    </Link>
                                    : */}
                                            <Link to={isPlanExpired ? "/plan" : "/discover"}
                                                className="nav-link">
                                                Discover
                                            </Link>
                                            {/* } */}
                                        </Nav.Item>
                                        :
                                        ''
                                    }
                                    {/* <Nav.Item className={activeItems['realtime']}>
                                    <Link to={isPlanExpired ? "/plan" :"/realtime"}
                                          className="nav-link">
                                        Monitor
                                    </Link>
                                </Nav.Item> */}

                                    {/* <Nav.Item className={activeItems['incidents']}>
                                {this.state.prefetch_load === true ? (
                                    <Link className="nav-link cursor-progress">Incidents <span class="dot-circle dot-circle--primary"></span></Link>
                                  ) : (
                                    <Link to={
                                        isPlanExpired
                                          ? "/plan"
                                          : (isDrxFreeTrailExpired ? "/discover" : "/incidents")
                                      }
                                      className={`nav-link${isPlanExpired || isDrxFreeTrailExpired ? " disabled" : ""}`}
                                    >
                                      Incidents <span class="dot-circle dot-circle--primary"></span></Link>
                                }
                                </Nav.Item> */}

                                    <Nav.Item className={activeItems['incidents']}>
                                        {this.state.prefetch_load === true ?
                                            <Link className="nav-link cursor-progress tw-flex tw-items-center tw-justify-center" style={{ display: "flex", alignItems: "center" }}>
                                                Incidents
                                                {incidentBadge && (
                                                    <span className="tw-ml-0.5 2xl:tw-ml-1 tw-px-1 2xl:tw-px-1.5 tw-py-0.5 tw-inline-flex tw-items-center tw-rounded-full tw-bg-white/20 tw-border tw-border-solid tw-border-white/25 tw-text-[10px] tw-font-medium tw-text-white tw-tracking-tight 2xl:tw-tracking-wide tw-leading-none">
                                                        {incidentBadge}
                                                    </span>
                                                )}
                                                <span className="dot-circle dot-circle--primary tw-ml-0.5 tw-mr-0.5 2xl:tw-ml-1 2xl:tw-mr-1"></span>
                                            </Link>
                                            :
                                            <NavDropdown title={
                                                <span className='tw-flex tw-items-center tw-justify-center'>
                                                    Incidents
                                                    {incidentBadge && (
                                                        <span className="tw-ml-0.5 2xl:tw-ml-1 tw-px-1 2xl:tw-px-1.5 tw-py-0.5 tw-inline-flex tw-items-center tw-rounded-full tw-bg-white/20 tw-border tw-border-solid tw-border-white/25 tw-text-[10px] tw-font-medium tw-text-white tw-tracking-tight 2xl:tw-tracking-wide tw-leading-none">
                                                            {incidentBadge}
                                                        </span>
                                                    )}
                                                    <span className="dot-circle dot-circle--primary tw-ml-0.5 tw-mr-0.5 2xl:tw-ml-1 2xl:tw-mr-1"></span>
                                                </span>
                                            } className={activeItems['profile']}
                                                id="basic-nav-dropdown">
                                                {/* <NavDropdown.Item className={activeItems['ml-profile']}
                                                    as={customLink}
                                                    link={"/ml-profile"}
                                                    tab={this.props.tab}>
                                                    <i>
                                                        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none">
                                                            <path d="M12 2C12.4724 2 12.9361 2.12611 13.3456 2.36402L13.3465 2.36314L19.6465 5.99982L19.65 6.00249C20.06 6.24163 20.401 6.58551 20.6379 6.99956C20.8747 7.41357 20.9995 7.88338 21 8.36154V15.6367C20.9995 16.1149 20.8747 16.5846 20.6379 16.9987C20.401 17.4127 20.06 17.7566 19.65 17.9957L19.6465 17.9984L13.3465 21.6351L13.3456 21.6342C12.9641 21.8558 12.5356 21.9788 12.0967 21.9947C12.0649 21.9981 12.0327 22 12 22C11.967 22 11.9345 21.9982 11.9024 21.9947C11.4636 21.9786 11.0349 21.8559 10.6535 21.6342V21.6351L4.35352 17.9984L4.35 17.9957C3.93999 17.7566 3.59904 17.4127 3.36211 16.9987C3.12526 16.5846 3.00049 16.1149 3 15.6367V8.36154L3.00615 8.18219C3.03368 7.76645 3.15497 7.3617 3.36211 6.99956C3.59903 6.58551 3.94003 6.24163 4.35 6.00249L4.35352 5.99982L10.6535 2.36314V2.36402C11.0632 2.12586 11.5273 2 12 2ZM4.8 15.6349L4.80791 15.7539C4.82341 15.8714 4.86134 15.9853 4.92041 16.0886C4.99869 16.2254 5.11142 16.3393 5.24648 16.4189L11.1 19.7972V12.5247L4.8 8.86762V15.6349ZM12.9 12.5247V19.7972L18.7535 16.4189C18.8886 16.3393 19.0013 16.2254 19.0796 16.0886C19.1583 15.951 19.1997 15.7947 19.2 15.6358V8.86762L12.9 12.5247ZM12 3.81834C11.842 3.81834 11.6868 3.86021 11.55 3.93998L11.5465 3.94176L5.72021 7.30409L12 10.9497L18.2789 7.30409L12.4535 3.94176L12.45 3.93998C12.3132 3.86021 12.158 3.81834 12 3.81834Z" fill="currentColor" />
                                                        </svg>
                                                    </i> Models
                                                </NavDropdown.Item> */}
                                                <NavDropdown.Item className={activeItems['incident-management']}
                                                    as={customLink}
                                                    link={"/incidents"}
                                                    tab={this.props.tab}>
                                                    <i>
                                                        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                            <path d="M10.8893 2C13.1671 2.00004 15.2664 2.30673 16.8268 2.82682C17.6023 3.08535 18.2951 3.41229 18.8112 3.81901C19.3172 4.21788 19.7773 4.79885 19.7773 5.55599V8.01302C19.3345 7.05342 18.4682 6.33161 17.4154 6.08984C17.5277 6.02298 17.627 5.95968 17.7096 5.89453C17.8536 5.78102 17.931 5.68903 17.9688 5.6276C17.9865 5.59864 17.9943 5.57897 17.9974 5.56901C17.9997 5.56128 18 5.55599 18 5.55599C18 5.55599 18.0002 5.55087 17.9974 5.54167C17.9943 5.53171 17.9865 5.51204 17.9688 5.48307C17.931 5.42165 17.8534 5.32946 17.7096 5.21615C17.4161 4.98491 16.9362 4.73698 16.2643 4.51302C14.9295 4.06816 13.0291 3.77738 10.8893 3.77734C8.74914 3.77734 6.84792 4.06806 5.51302 4.51302C4.84095 4.73705 4.36119 4.98485 4.06771 5.21615C3.92382 5.32958 3.84633 5.42165 3.80859 5.48307C3.79083 5.51204 3.783 5.53171 3.77995 5.54167C3.77718 5.55078 3.77734 5.55599 3.77734 5.55599C3.77734 5.55599 3.77766 5.56135 3.77995 5.56901C3.783 5.57894 3.79092 5.59875 3.80859 5.6276C3.84628 5.689 3.92386 5.7811 4.06771 5.89453C4.36118 6.12581 4.84102 6.37364 5.51302 6.59766C6.84792 7.04262 8.74914 7.33333 10.8893 7.33333C11.0297 7.33333 11.169 7.32798 11.3073 7.32552C10.9141 7.82632 10.6539 8.43729 10.5859 9.10547C8.42512 9.07961 6.44161 8.78216 4.95052 8.28516C4.52974 8.14488 4.13411 7.98198 3.77734 7.79948V11.7799C3.77734 11.7799 3.77889 11.7841 3.77995 11.7878C3.78272 11.7968 3.78972 11.8152 3.80599 11.8424C3.84134 11.9014 3.91588 11.9927 4.05599 12.1055C4.34143 12.3351 4.81809 12.5887 5.51302 12.8203C6.47191 13.1399 7.69482 13.3656 9.03906 13.4766C9.01657 13.4979 8.99332 13.5184 8.97135 13.5404C8.52074 13.9911 8.21002 14.5542 8.0612 15.1641C6.91686 15.0262 5.85249 14.8072 4.95052 14.5065C4.52473 14.3646 4.13043 14.2018 3.77734 14.0208V18.0013C3.77734 18.0013 3.77885 18.0053 3.77995 18.0091C3.7826 18.018 3.78927 18.0372 3.80599 18.0651C3.84134 18.1241 3.91588 18.2154 4.05599 18.3281C4.34145 18.5577 4.81826 18.8114 5.51302 19.043C5.6684 19.0948 5.83138 19.1419 6 19.1888V21.0221C5.63162 20.9335 5.27972 20.8389 4.95052 20.7292C4.14569 20.4609 3.45243 20.1234 2.94141 19.7122C2.43852 19.3075 2 18.7336 2 18V5.55599C2 4.79882 2.46141 4.21788 2.96745 3.81901C3.48345 3.41249 4.17531 3.08526 4.95052 2.82682C6.51106 2.30664 8.61123 2 10.8893 2Z" fill="currentColor" />
                                                            <path d="M9.87879 18.3636V20.7879H12.303V18.3636H9.87879ZM18.3636 18.3636V20.7879H20.7879V18.3636H18.3636ZM14.1212 9.87879V12.303H16.5455V9.87879H14.1212ZM17.7576 12.303C17.7576 12.9725 17.2149 13.5152 16.5455 13.5152H15.9394V14.7273H18.9697C19.2912 14.7273 19.5994 14.8551 19.8267 15.0824C20.054 15.3097 20.1818 15.6179 20.1818 15.9394V17.1515H20.7879C21.4573 17.1515 22 17.6942 22 18.3636V20.7879C22 21.4573 21.4573 22 20.7879 22H18.3636C17.6942 22 17.1515 21.4573 17.1515 20.7879V18.3636C17.1515 17.6942 17.6942 17.1515 18.3636 17.1515H18.9697V15.9394H11.697V17.1515H12.303C12.9725 17.1515 13.5152 17.6942 13.5152 18.3636V20.7879C13.5152 21.4573 12.9725 22 12.303 22H9.87879C9.20935 22 8.66667 21.4573 8.66667 20.7879V18.3636C8.66667 17.6942 9.20935 17.1515 9.87879 17.1515H10.4848V15.9394C10.4848 15.6179 10.6126 15.3097 10.84 15.0824C11.0673 14.8551 11.3755 14.7273 11.697 14.7273H14.7273V13.5152H14.1212C13.4518 13.5152 12.9091 12.9725 12.9091 12.303V9.87879C12.9091 9.20935 13.4518 8.66667 14.1212 8.66667H16.5455C17.2149 8.66667 17.7576 9.20935 17.7576 9.87879V12.303Z" fill="currentColor" />
                                                        </svg>
                                                    </i> Data and Pipelines
                                                </NavDropdown.Item>
                                                {deployed_domain!=="" && deployed_domain!==undefined && <NavDropdown.Item className={activeItems['vertical-incidents']}
                                                    as={customLink}
                                                    link={"/vertical-incidents"}
                                                    tab={this.props.tab}>
                                                    <i>
                                                        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                            <path d="M20.1818 15.3776C17.6702 16.7019 14.8622 17.4026 12 17.4026C9.13776 17.4026 6.32982 16.7019 3.81818 15.3776V18.3C3.81818 18.7971 4.2252 19.2 4.72727 19.2H19.2727C19.7748 19.2 20.1818 18.7971 20.1818 18.3V15.3776ZM12.0089 12C12.511 12 12.918 12.4029 12.918 12.9C12.918 13.3971 12.511 13.8 12.0089 13.8H12C11.4979 13.8 11.0909 13.3971 11.0909 12.9C11.0909 12.4029 11.4979 12 12 12H12.0089ZM20.1818 9.3C20.1818 8.80294 19.7748 8.4 19.2727 8.4H4.72727C4.2252 8.4 3.81818 8.80294 3.81818 9.3V13.3043C6.27535 14.8043 9.10693 15.6026 12 15.6026C14.8931 15.6026 17.7246 14.8043 20.1818 13.3043V9.3ZM14.7273 5.7C14.7273 5.46131 14.6314 5.23245 14.4609 5.06367C14.2904 4.89489 14.0593 4.8 13.8182 4.8H10.1818C9.94071 4.8 9.70955 4.89489 9.53906 5.06367C9.36858 5.23245 9.27273 5.46131 9.27273 5.7V6.6H14.7273V5.7ZM16.5455 6.6H19.2727C20.779 6.6 22 7.80883 22 9.3V18.3C22 19.7912 20.779 21 19.2727 21H4.72727C3.22104 21 2 19.7912 2 18.3V9.3C2 7.80883 3.22104 6.6 4.72727 6.6H7.45455V5.7C7.45455 4.98392 7.74209 4.29736 8.25355 3.79102C8.76501 3.28467 9.4585 3 10.1818 3H13.8182C14.5415 3 15.235 3.28467 15.7464 3.79102C16.2579 4.29736 16.5455 4.98392 16.5455 5.7V6.6Z" fill="currentColor" />
                                                        </svg>
                                                    </i> {  deployed_domain.toString().charAt(0).toUpperCase() +
  deployed_domain.toString().slice(1).toLowerCase()
} Business
                                                </NavDropdown.Item>}
                                            </NavDropdown>
                                          }
                                    </Nav.Item>

                                    {enablePowerBiTab
                                        ?
                                        <NavDropdown title="Power BI" className={activeItems['powerbi']}
                                            id="basic-nav-dropdown">
                                            <NavDropdown.Item className={activeItems['pbi-setup']}
                                                as={customLink}
                                                link={isPlanExpired ? "/plan" : "/pbi-setup"}
                                                tab={this.props.tab}>
                                                <i className='icon_powerbi'></i>Power BI Setup
                                            </NavDropdown.Item>
                                            <NavDropdown.Item className={activeItems['pbi-report']}
                                                as={customLink}
                                                link={isPlanExpired ? "/plan" : "/pbi-report"}
                                                tab={this.props.tab}>
                                                <i className='icon_powerbi-error'></i>Power BI Error
                                            </NavDropdown.Item>
                                            {/* JIRA ISSUE QPS-2153 <NavDropdown.Item className={activeItems['pbi-mapping']}
                                                      as={customLink}
                                                      link={isPlanExpired ? "/plan" :"/pbi-mapping"}
                                                      tab={this.props.tab}>
                                        <i className='icon_powerbi-mapping'></i>Power BI Mapping
                                    </NavDropdown.Item> */}
                                        </NavDropdown>
                                        : ""}
                                </Nav>
                                {(this.props.page === "incidents" || this.props.page === "discover" || this.props.page === "profile" || this.props.page === "monitor" || this.props.page === "realtime" || this.props.page === "vertical-incidents") && <div className="qd-header__topbar-item qd-env-dropdown">
                                    <Dropdown alignRight>
                                        <Dropdown.Toggle as={envToggle} selectedEnv={selectedEnv} latestEnvName={this.props.page === "realtime" || this.props.page === "incidents" || this.props.page === "vertical-incidents" ? this.props.selectedEnvName : this.props.latest_env_name} />
                                        <Dropdown.Menu>
                                            <div className="qd-env-dropdown-menu__head">
                                                <div className="qd-search-bar">
                                                    <div className="input-group">
                                                        <div className="input-group-prepend">
                                                            <button id="button-addon4" type="button" className="btn"><FontAwesomeIcon icon={faSearch} /></button>
                                                        </div>
                                                        <input type="search" placeholder="Search..." className="form-control" onChange={this.handleEnvSearchChange} value={this.state.env_search_text} />
                                                    </div>
                                                    {this.state.env_search_text && <button className="btn btn-clear" title="clear"><i className="icon-close" onClick={this.clearEnvSearch} value={this.state.env_search_text}></i></button>}
                                                </div>
                                            </div>
                                            <div className="qd-env-dropdown-menu__body">
                                                <Dropdown.Header>Environment</Dropdown.Header>
                                                {this.props.cachenable === true ?
                                                    this.state.env_search_text === "" ? ((this.state.environment !== undefined || this.state.environment !== null) && this.state.environment && this.state.environment.length > 0 ? (this.sortEnvironments(this.state.environment).map((env, index) => (
                                                        <Dropdown.Item className={`dropdown-item--all ${this.props.selectedEnvName === env.label ? 'active' : ''}`} onClick={() => this.handleEnvSelect(env, index, this.props.selectedEnvName)} style={{ pointerEvents: !this.getIntegrationStatus(env.label) ? 'none' : 'auto', opacity: !this.getIntegrationStatus(env.label) ? 0.5 : 1, cursor: !this.getIntegrationStatus(env.label) ? 'not-allowed' : 'pointer', }} disabled={!this.getIntegrationStatus(env.label)} >
                                                            <span className="env-tag" style={{ backgroundColor: colors[index % colors.length], }}>
                                                                {env.label[0].toUpperCase()}
                                                            </span>
                                                            <span className="menu-text">{env.label}</span>
                                                        </Dropdown.Item>
                                                    ))) : (<div class="alert_notree-search-match"><p>No environment found</p></div>)) : this.state.filteredEnv !== undefined && this.state.filteredEnv.length > 0 ? (
                                                        this.sortEnvironments(this.state.filteredEnv).map((env, index) => (
                                                            <Dropdown.Item className={`dropdown-item--all ${this.props.selectedEnvName === env.label ? 'active' : ''}`} onClick={() => this.handleEnvSelect(env, index, this.props.selectedEnvName)} style={{ pointerEvents: !this.getIntegrationStatus(env.label) ? 'none' : 'auto', opacity: !this.getIntegrationStatus(env.label) ? 0.5 : 1, cursor: !this.getIntegrationStatus(env.label) ? 'not-allowed' : 'pointer', }} disabled={!this.getIntegrationStatus(env.label)}>
                                                                <span className="env-tag" style={{ backgroundColor: colors[index % colors.length], }}>
                                                                    {env.label[0].toUpperCase()}
                                                                </span>
                                                                <span className="menu-text">{env.label}</span>
                                                            </Dropdown.Item>
                                                        ))) : (<div className="alert_notree-search-match"><p>No environment found</p></div>)
                                                    :
                                                    this.props.discoverCache === true ? this.props.search_text === "" ? ((this.state.environment !== undefined || this.state.environment !== null) && this.state.environment && this.state.environment.length > 0 ? (this.sortEnvironments(this.state.environment).map((env, index) => (
                                                        <Dropdown.Item className={`dropdown-item--all ${this.props.selectedEnvName === env.label ? 'active' : ''}`} onClick={() => this.props.handleSelect(env, index, this.props.selectedEnvName)} style={{ pointerEvents: !this.getIntegrationStatus(env.label) ? 'none' : 'auto', opacity: !this.getIntegrationStatus(env.label) ? 0.5 : 1, cursor: !this.getIntegrationStatus(env.label) ? 'not-allowed' : 'pointer', }} disabled={!this.getIntegrationStatus(env.label)} >
                                                            <span className="env-tag" style={{ backgroundColor: env.label === this.props.latest_env_name ? '#4ca3ff' : colors[index % colors.length], }}>
                                                                {env.label[0].toUpperCase()}
                                                            </span>
                                                            <span className="menu-text">{env.label}</span>
                                                        </Dropdown.Item>
                                                    ))) : (<div class="alert_notree-search-match"><p>No environment found</p></div>)) : this.props.filteredEnv !== undefined && this.props.filteredEnv.length > 0 ? (
                                                        this.sortEnvironments(this.props.filteredEnv).map((env, index) => (
                                                            <Dropdown.Item className={`dropdown-item--all ${this.props.selectedEnvName === env.label ? 'active' : ''}`} onClick={() => this.props.handleSelect(env, index, this.props.selectedEnvName)} style={{ pointerEvents: !this.getIntegrationStatus(env.label) ? 'none' : 'auto', opacity: !this.getIntegrationStatus(env.label) ? 0.5 : 1, cursor: !this.getIntegrationStatus(env.label) ? 'not-allowed' : 'pointer', }} disabled={!this.getIntegrationStatus(env.label)}>
                                                                <span className="env-tag" style={{ backgroundColor: env.label === this.props.latest_env_name ? '#4ca3ff' : colors[index % colors.length], }}>
                                                                    {env.label[0].toUpperCase()}
                                                                </span>
                                                                <span className="menu-text">{env.label}</span>
                                                            </Dropdown.Item>
                                                        ))) : (<div className="alert_notree-search-match"><p>No environment found</p></div>)
                                                        : this.props.search_text === "" ? (Array.isArray(this.props.environment) && this.props.environment.length > 0 ? (this.sortEnvironments(this.props.environment).map((env, index) => (
                                                            <Dropdown.Item className={`dropdown-item--all ${env.integration_ids.length === 0 ? "disabled" : ""}${this.props.selectedEnvName === env.label ? 'active' : ''}`} style={{ pointerEvents: env.integration_ids.length === 0 ? 'none' : 'auto', opacity: env.integration_ids.length === 0 ? 0.5 : 1, cursor: env.integration_ids.length === 0 ? 'not-allowed' : 'pointer', }} onClick={() => env.integration_ids.length > 0 && this.props.handleSelect(env, index, this.props.latest_env_name)}>
                                                                <span className="env-tag" style={{ backgroundColor: env.label === this.props.latest_env_name ? '#4ca3ff' : colors[index % colors.length], }}>
                                                                    {env.label[0].toUpperCase()}
                                                                </span>
                                                                <span className="menu-text">{env.label}</span>
                                                            </Dropdown.Item>
                                                        ))) : (<div className="alert_notree-search-match"><p>No environment found</p></div>)) : this.props.filteredEnv !== undefined && this.props.filteredEnv.length > 0 ? (
                                                            this.sortEnvironments(this.props.filteredEnv).map((env, index) => (
                                                                <Dropdown.Item className={`dropdown-item--all ${env.integration_ids.length === 0 ? "disabled" : ""}${this.props.selectedEnvName === env.label ? 'active' : ''}`} style={{ pointerEvents: env.integration_ids.length === 0 ? 'none' : 'auto', opacity: env.integration_ids.length === 0 ? 0.5 : 1, cursor: env.integration_ids.length === 0 ? 'not-allowed' : 'pointer', }} onClick={() => env.integration_ids.length > 0 && this.props.handleSelect(env, index, this.props.latest_env_name)}>
                                                                    <span className="env-tag" style={{ backgroundColor: env.label === this.props.latest_env_name ? '#4ca3ff' : colors[index % colors.length], }}>
                                                                        {env.label[0].toUpperCase()}
                                                                    </span>
                                                                    <span className="menu-text">{env.label}</span>
                                                                </Dropdown.Item>
                                                            ))) : (<div class="alert_notree-search-match"><p>No environment found</p></div>)}
                                            </div>
                                        </Dropdown.Menu>
                                    </Dropdown>
                                </div>}
                                <div className="qd-header__topbar-item d-md-none d-lg-inline-block">
                                    {/* <div className="qd-header__topbar-wrapper">
                                        <div className="qd-header__topbar-icon" onClick={this.handleShowAiAssistant}>
                                            <span className="nav-link">
                                                <svg className='d-block' width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                    <rect width="24" height="24" fill="none" />
                                                    <path d="M12 1C5.928 1 1 5.928 1 12C1 18.072 5.928 23 12 23C18.072 23 23 18.072 23 12C23 5.928 18.072 1 12 1ZM21.988 10.966L19.667 9.074L20.877 7.314C21.471 8.425 21.845 9.657 21.988 10.966ZM9.283 10.526C9.184 10.834 9.063 11.142 8.92 11.461C8.414 12.627 7.776 13.606 7.105 14.409C7.05 14.145 7.006 13.881 6.962 13.606C6.654 11.505 6.808 9.602 7.16 7.985C7.534 8.106 7.93 8.238 8.337 8.403L9.283 10.537V10.526ZM8.953 8.645C9.195 8.744 9.448 8.865 9.701 8.986C9.646 9.283 9.569 9.58 9.481 9.888L8.953 8.645ZM9.47 11.692C9.525 11.571 9.591 11.45 9.635 11.318L11.483 15.498C10.515 16.752 9.547 17.808 8.634 18.71C8.084 17.665 7.567 16.422 7.237 14.992C8.04 14.112 8.832 13.023 9.47 11.692ZM9.866 10.768C10.064 10.273 10.207 9.789 10.328 9.305C10.823 9.558 11.318 9.855 11.824 10.174C11.901 10.812 12.055 11.483 12.286 12.165C12.451 12.66 12.649 13.122 12.869 13.551C12.495 14.112 12.132 14.64 11.747 15.146L9.866 10.768ZM13.683 10.064C13.254 9.767 12.825 9.503 12.396 9.261C12.319 7.49 12.704 5.917 13.155 4.707L16.037 7.226C15.641 8.304 15.146 9.47 14.53 10.669C14.255 10.471 13.98 10.262 13.683 10.064ZM13.947 11.769C13.771 12.099 13.573 12.429 13.375 12.759C13.331 12.825 13.287 12.902 13.243 12.968C13.144 12.726 13.045 12.484 12.968 12.231C12.792 11.703 12.66 11.186 12.572 10.691C12.638 10.735 12.704 10.779 12.77 10.834C13.188 11.142 13.584 11.461 13.958 11.78L13.947 11.769ZM13.496 14.662C13.749 15.058 14.024 15.432 14.321 15.762L12.935 17.907L12.231 16.268C12.649 15.762 13.078 15.223 13.496 14.651V14.662ZM13.837 14.189C14.101 13.815 14.365 13.419 14.629 13.023C14.717 12.891 14.794 12.759 14.871 12.627C15.19 12.935 15.487 13.243 15.762 13.551L14.607 15.333C14.332 14.981 14.079 14.596 13.837 14.189ZM15.542 11.494C16.191 10.361 16.73 9.261 17.17 8.227L18.468 9.371L16.521 12.385C16.224 12.088 15.894 11.791 15.553 11.494H15.542ZM19.095 9.921L21.438 11.978C20.613 12.473 19.469 13.298 18.501 14.618C18.083 14.068 17.599 13.485 17.038 12.902L19.095 9.91V9.921ZM18.435 4.718C18.479 4.597 18.501 4.487 18.534 4.377C19.128 4.872 19.656 5.444 20.107 6.071C20.195 6.192 20.283 6.313 20.36 6.423L19.007 8.513L17.544 7.314C17.907 6.379 18.204 5.499 18.435 4.707V4.718ZM16.092 2.837C16.466 3.002 16.818 3.189 17.17 3.398C17.148 3.486 17.126 3.574 17.115 3.651C16.928 4.454 16.686 5.356 16.345 6.346L13.452 3.992C13.848 3.112 14.244 2.496 14.409 2.243C14.992 2.386 15.553 2.573 16.092 2.826V2.837ZM12 1.957C12.583 1.957 13.166 2.012 13.716 2.111C13.551 2.364 13.243 2.859 12.913 3.552L11.01 2.001C11.34 1.968 11.659 1.957 12 1.957ZM10.229 2.122L12.627 4.234C12.132 5.433 11.692 7.039 11.725 8.887C11.329 8.678 10.933 8.491 10.548 8.315C11.054 5.433 10.46 2.969 10.229 2.133V2.122ZM9.349 2.694C9.602 3.497 10.152 5.51 9.855 8.007C9.382 7.809 8.909 7.644 8.458 7.49L7.765 5.873C8.304 4.366 9.019 3.211 9.349 2.683V2.694ZM7.534 6.566L7.864 7.314C7.688 7.259 7.523 7.215 7.358 7.171C7.413 6.962 7.479 6.764 7.534 6.566ZM7.171 3.2C7.094 3.365 6.995 3.585 6.885 3.849L6.72 3.475C6.863 3.376 7.017 3.288 7.171 3.211V3.2ZM6.28 3.75L6.61 4.509C6.379 5.136 6.126 5.928 5.917 6.841C5.477 6.753 5.059 6.687 4.685 6.632C4.685 6.06 4.641 5.576 4.586 5.224C5.092 4.674 5.653 4.179 6.269 3.75H6.28ZM4.289 9.162C4.498 8.513 4.608 7.908 4.663 7.347C5.004 7.413 5.378 7.49 5.785 7.589C5.411 9.602 5.312 12.11 6.016 14.86C6.06 15.047 6.115 15.234 6.17 15.421C5.675 15.894 5.202 16.29 4.762 16.598L2.628 12.11C3.222 11.417 3.882 10.438 4.3 9.151L4.289 9.162ZM4.058 5.862C4.08 6.071 4.102 6.302 4.102 6.566C3.926 6.544 3.75 6.533 3.596 6.522C3.739 6.291 3.893 6.071 4.069 5.862H4.058ZM3.211 7.138C3.464 7.16 3.75 7.204 4.08 7.248C4.047 7.831 3.937 8.491 3.728 9.195C3.398 10.262 2.914 11.12 2.452 11.769L2.023 10.867C2.166 9.525 2.584 8.26 3.211 7.138ZM1.968 12.22L2.023 12.319C2.023 12.319 1.99 12.352 1.979 12.374C1.979 12.319 1.979 12.275 1.979 12.22H1.968ZM1.99 12.759C2.045 12.715 2.1 12.66 2.155 12.594L4.344 16.873C4.036 17.082 3.761 17.247 3.53 17.379C2.661 16.026 2.122 14.453 1.99 12.77V12.759ZM3.75 17.72C3.981 17.599 4.245 17.434 4.542 17.247L5.95 20.008C5.103 19.37 4.366 18.589 3.761 17.72H3.75ZM6.577 20.448L4.927 16.983C5.356 16.686 5.818 16.334 6.302 15.905C6.731 17.247 7.303 18.413 7.897 19.414C7.457 19.821 7.039 20.173 6.654 20.503C6.632 20.503 6.61 20.481 6.577 20.459V20.448ZM7.435 20.943C7.732 20.701 8.051 20.448 8.381 20.162C8.788 20.767 9.195 21.295 9.58 21.735C8.832 21.548 8.117 21.284 7.446 20.932L7.435 20.943ZM9.107 19.524C10.009 18.699 10.988 17.731 11.967 16.587L12.715 18.259L10.57 21.57C10.13 21.042 9.613 20.36 9.107 19.524ZM12 22.043C11.637 22.043 11.274 22.021 10.911 21.988C10.878 21.988 10.845 21.988 10.812 21.977L10.845 21.922L12.957 18.853L14.255 21.79C13.529 21.955 12.77 22.043 11.989 22.043H12ZM16.543 20.954C15.916 21.273 15.256 21.526 14.574 21.702L13.199 18.512L14.761 16.246C15.476 16.994 16.224 17.577 16.884 18.017C16.576 19.183 16.532 20.228 16.554 20.954H16.543ZM15.025 15.85L16.224 14.09C16.774 14.75 17.236 15.399 17.632 16.015C17.346 16.576 17.126 17.126 16.972 17.654C16.334 17.181 15.652 16.587 15.025 15.861V15.85ZM17.214 20.58C17.247 20.052 17.335 19.304 17.577 18.446C18.303 18.864 18.853 19.073 19.04 19.15C18.49 19.689 17.874 20.173 17.203 20.569L17.214 20.58ZM19.205 18.985C19.205 18.985 19.194 18.952 19.183 18.93C18.809 18.765 18.281 18.501 17.676 18.127C17.808 17.731 17.973 17.324 18.182 16.906C18.633 17.698 18.963 18.391 19.183 18.93C19.205 18.93 19.216 18.941 19.227 18.952C19.227 18.963 19.216 18.974 19.205 18.985ZM19.095 15.443C20.107 14.123 21.262 13.364 21.988 12.968C21.834 14.64 21.262 16.202 20.371 17.544C20.063 16.972 19.645 16.246 19.095 15.443Z" fill="white" />
                                                </svg>
                                            </span>
                                        </div>
                                    </div> */}
                                    <button
                                        style={{
                                            position: 'relative',
                                            background: 'rgba(0, 0, 0, 0.25)',
                                            border: 'none',
                                            outline: 'none'
                                        }}
                                        className="tw-rounded-full !tw-p-0 tw-text-[#E2EAFE] tw-text-sm tw-font-medium tw-inline-flex tw-items-center tw-cursor-pointer tw-transition-all tw-duration-300"
                                        onClick={this.handleShowAiAssistant}
                                    >
                                        <div className="tw-flex tw-items-center tw-gap-[8px] tw-bg-transparent tw-py-2 tw-pr-[12px] tw-pl-[8px] tw-rounded-full tw-relative tw-z-[2] tw-font-semibold">
                                            <Image className="!tw-w-[20px] !tw-h-[20px] tw-flex-shrink-0" src={"icon_ai_assistant"} />
                                            <span className="tw-flex-shrink-0">Ask QualdoAI</span>
                                        </div>
                                        <div
                                            style={{
                                                position: 'absolute',
                                                inset: 0,
                                                borderRadius: '9999px',
                                                padding: '1px',
                                                background: 'linear-gradient(45.22deg, #446EFF 14.68%, #2E96FF 40.83%, #B1C5FF 73.34%)',
                                                WebkitMask: 'linear-gradient(#fff 0 0) content-box, linear-gradient(#fff 0 0)',
                                                WebkitMaskComposite: 'xor',
                                                maskComposite: 'exclude',
                                                pointerEvents: 'none',
                                                zIndex: 1
                                            }}
                                        />
                                    </button>
                                </div>
                                {this.props.page !== "discover" && enableDiscoveryTab ? <div className="qd-header__topbar-item qd-quick-search d-none d-xl-inline-block">
                                    {/* <form className="qd-quick-search__form" onKeyDown={this.onKeyDownHandler}>
                                  <div className="input-group">
                                    <div className="input-group-prepend">
                                      <span className="input-group-text"><i><FontAwesomeIcon icon={faSearch}/></i></span>
                                    </div>
                                    <input type="text" ref={n => this.input = n} className="form-control qd-quick-search__input" placeholder="Search..."/>
                                  </div>
                                </form> */}
                                    <form className="qd-quick-search__form" onKeyDown={this.onKeyDownHandler}>
                                        <div className="input-group">
                                            <input type="text" ref={n => this.input = n} className="form-control qd-quick-search__input" placeholder="Search..." />
                                        </div>
                                    </form>
                                </div> : ""}
                                <div className="qd-header__topbar-item d-md-none d-lg-inline-block">
                                    <div className="qd-header__topbar-wrapper">
                                        <div className="qd-header__topbar-icon"
                                            onClick={this.handleHelp}>
                                            <span className="nav-link" onClick={this.handleHelp}>
                                                {/* <FontAwesomeIcon onClick={this.handleHelp} color="#fff" icon={faQuestion} /> */}
                                                <svg width="24" height="25" viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                    <path d="M12.0017 22C10.6877 22 9.45267 21.7507 8.2965 21.252C7.14033 20.7533 6.13467 20.0766 5.2795 19.2218C4.42433 18.3669 3.74725 17.3617 3.24825 16.206C2.74942 15.0503 2.5 13.8156 2.5 12.5017C2.5 11.1877 2.74933 9.95267 3.248 8.7965C3.74667 7.64033 4.42342 6.63467 5.27825 5.7795C6.13308 4.92433 7.13833 4.24725 8.294 3.74825C9.44967 3.24942 10.6844 3 11.9983 3C13.3123 3 14.5473 3.24933 15.7035 3.748C16.8597 4.24667 17.8653 4.92342 18.7205 5.77825C19.5757 6.63308 20.2528 7.63833 20.7518 8.794C21.2506 9.94967 21.5 11.1844 21.5 12.4983C21.5 13.8123 21.2507 15.0473 20.752 16.2035C20.2533 17.3597 19.5766 18.3653 18.7218 19.2205C17.8669 20.0757 16.8617 20.7528 15.706 21.2518C14.5503 21.7506 13.3156 22 12.0017 22ZM12 20.5C14.2333 20.5 16.125 19.725 17.675 18.175C19.225 16.625 20 14.7333 20 12.5C20 10.2667 19.225 8.375 17.675 6.825C16.125 5.275 14.2333 4.5 12 4.5C9.76667 4.5 7.875 5.275 6.325 6.825C4.775 8.375 4 10.2667 4 12.5C4 14.7333 4.775 16.625 6.325 18.175C7.875 19.725 9.76667 20.5 12 20.5Z" fill="white" />
                                                    <path d="M11.4032 12.7211C11.8967 11.8432 12.8452 11.3253 13.3963 10.5484C13.9795 9.73368 13.6527 8.21158 11.9992 8.21158C10.9161 8.21158 10.3842 9.02 10.1599 9.68947L8.5 9.00105C8.95503 7.65579 10.1919 6.5 11.9928 6.5C13.4989 6.5 14.5307 7.17579 15.0562 8.02211C15.5049 8.74842 15.7676 10.1063 15.0755 11.1168C14.3064 12.2347 13.5694 12.5758 13.172 13.2958C13.0118 13.5863 12.9477 13.7758 12.9477 14.7105H11.0956C11.0892 14.2179 11.0123 13.4158 11.4032 12.7211ZM13.281 17.2368C13.281 17.9316 12.7042 18.5 11.9992 18.5C11.2943 18.5 10.7175 17.9316 10.7175 17.2368C10.7175 16.5421 11.2943 15.9737 11.9992 15.9737C12.7042 15.9737 13.281 16.5421 13.281 17.2368Z" fill="white" />
                                                </svg>
                                            </span>
                                        </div>
                                    </div>
                                    {this.state.zendeskShow === true ? <HelpZendesk /> : ""}
                                </div>
                                <div className="qd-header__topbar-item dropdown d-lg-inline-block qd-header_notification">
                                    <div className="qd-header__topbar-wrapper dropdown"
                                        id="dropdown__user-notification"
                                        key={`user_notification_${notificationCircleCount}`}
                                    >

                                        <Dropdown>
                                            <Dropdown.Toggle unReadMsg={currUnreadNotifications} as={bellToggle} />
                                            <span className={notificationAlertClassName}
                                                key={`notificationCircle${notificationCircleCount}`}>
                                                {notificationCircleCount}
                                            </span>
                                            {this.state.prefetch_load !== true && currUnreadNotifications !== null && (isPlanExpired !== true && isDrxFreeTrailExpired !== true) ?
                                                <Dropdown.Menu className="dropdown-menu__user-notification has-caret" popper={false} ref={(el) => { if (el) { el.style.margin = ''; } }}>
                                                    <Dropdown.Item className="dropdown-menu_user-notification__head">
                                                        <span>
                                                            {currUnreadNotifications.length} New Qualdo Notifications
                                                        </span>
                                                    </Dropdown.Item>

                                                    <div className="user-notification__list">
                                                        {this.renderNotifications()}
                                                    </div>

                                                    <Dropdown.Item className="dropdown-menu_user-notification__footer"
                                                        name='view all'
                                                        href='/notification'>
                                                        View All Notifications
                                                        <i>
                                                            <FontAwesomeIcon icon={faArrowRight} />
                                                        </i>
                                                    </Dropdown.Item>
                                                </Dropdown.Menu> : ""
                                            }
                                        </Dropdown>


                                    </div>
                                </div>
                                <div className="qd-header__topbar-item qd-header__topbar-item--user">
                                    <div className="qd-header__topbar-wrapper dropdown">
                                        <span className="qd-header__topbar-welcome">Hi,</span>
                                        <span className="qd-header__topbar-username">
                                            {localStorage.getItem('user_name')}
                                        </span>
                                        <Dropdown alignRight>
                                            <Dropdown.Toggle as={userToggle}>
                                            </Dropdown.Toggle>

                                            <Dropdown.Menu>
                                                <Dropdown.Item onClick={this.state.prefetch_load !== true ? this.onItemClick : ""} to={isDrxFreeTrailExpired === true ? "" : this.state.prefetch_load !== true ? "/settings" : ""} as={Link} activeClassName="active">
                                                    <i><UserPen size={16} color="currentColor" /></i>Profile</Dropdown.Item>
                                                <Dropdown.Item href={get_document_link("index")} target="_blank">
                                                    <i><BookText size={16} color="currentColor" /></i>{QUALDO_DOCUMENTATION}
                                                </Dropdown.Item>
                                                <DropdownButton
                                                    className="dropdown-item-submenu p-0"
                                                    drop="left"
                                                    variant=" "
                                                    // title={
                                                    //     <>{this.state.theme === "light" ? <Sun size={16} color="currentColor" /> : <Moon size={16} color="currentColor" />} Theme</>
                                                    // }
                                                    title={
                                                        <><i><Palette size={16} color="currentColor" /></i>Theme</>
                                                    }
                                                >

                                                    <Dropdown.Item className={(this.state.theme === 'light' && this.state.themeSystem === '') ? 'active' : ''} onClick={() => this.toggleTheme("light")}><i><Sun size={16} color="currentColor" /></i>Light</Dropdown.Item>
                                                    <Dropdown.Item className={(this.state.theme === 'dark' && this.state.themeSystem === '') ? 'active' : ''} onClick={() => this.toggleTheme("dark")}><i><Moon size={16} color="currentColor" /></i>Dark</Dropdown.Item>
                                                    <Dropdown.Item className={this.state.themeSystem === 'system' ? 'active' : ''} onClick={() => this.setSystemTheme()}><i><Monitor size={16} color="currentColor" /></i>System</Dropdown.Item>
                                                </DropdownButton>
                                                {this.check_access_billing(isDrxFreeTrailExpired)}
                                                <Dropdown.Item name='logout'
                                                    onClick={handleClick.bind(this)}>
                                                    <i><LogOut size={16} color="currentColor" /></i>
                                                    Log Out
                                                </Dropdown.Item>
                                            </Dropdown.Menu>
                                        </Dropdown>
                                    </div>
                                </div>
                            </Navbar.Collapse>
                        </Navbar>


                    </div>
                    {/* <Offline polling={false} interval={1000} onChange={this.pageRefresh}>
                    <OfflineComponent>
                    </OfflineComponent>
                </Offline> */}
                    {this.props.loader !== undefined && this.props.loader !== null && this.props.loader === true &&
                        <ProgressLoader modifierClass={this.props.loader === "incidents" ? "progress-loader--light" : "progress-loader--danger"} /> /* menu name chceck  "progress-loader--danger" add this classname for incident management */
                    }
                    <NetworkStatusAlert />
                    <AiAssistant open={this.state.showAiAssistant} onAiAssistantClose={this.handleHideAiAssistant} />
                </header>
            </>
        );
    }
}


const mapStateToProps = state => {
    return state;
}

export default connect(mapStateToProps, null, null, { forwardRef: true })(NavigationHeader);


export function SimpleHeader() {
    let DataSetupStatus = localStorage.getItem("DataSetupStatus");
    const canShowQuickStart = DataSetupStatus !== "false";
    //let BRAND_LOGO = process.env.REACT_APP_CUSTOM_BRAND_LOGO
    let BRAND_LOGO = getBrandLogo()

    let decrypt_data = decryptForLocalUsage(localStorage.getItem(LOCAL_STORE_KEY))
    let warning_message = decrypt_data['warning_message']
    // let warning_message = localStorage.getItem("warning_message");

    let showWarning = false;
    if (warning_message !== undefined && warning_message !== null && warning_message !== '' && warning_message !== 'undefined') {
        showWarning = true;
    }

    return (
        <>
            {
                showWarning === true ?
                    <WarningMessageHeader warning_message={warning_message} quick_start={true} />
                    : ''
            }

            <header className="qd-header">
                <div className="qd-header-container navbar navbar-expand-md">
                    {(SUB_BRAND !== null && SUB_BRAND !== undefined) ?
                        <dt className="title-text"><small >{SUB_BRAND}</small></dt>
                        :
                        ''
                    }
                    <div className="qd-header__brand">
                        <a href="#!">
                            <Image
                                className="qd-header__brand-logo-default"
                                src={BRAND_LOGO}
                            />
                        </a>
                    </div>
                    <button className="navbar-toggler collapsed" type="button"
                        data-toggle="collapse" data-target="#navbarCollapse"
                        aria-controls="navbarCollapse" aria-expanded="false"
                        aria-label="Toggle navigation">
                        <span className="navbar-toggler-icon" />
                    </button>
                    <div className="navbar-collapse collapse flex-row-reverse" id="navbarCollapse">
                        <div className="qd-header__topbar-item qd-header__topbar-item--user">
                            <div className="qd-header__topbar-wrapper dropdown">
                                <span className="qd-header__topbar-welcome">Hi,</span>
                                <span className="qd-header__topbar-username">
                                    {localStorage.getItem('user_name')}
                                </span>
                                <Dropdown alignRight>
                                    <Dropdown.Toggle as={userToggle}>
                                    </Dropdown.Toggle>
                                    <Dropdown.Menu>
                                        <Dropdown.Item href="/settings">
                                            <i><FontAwesomeIcon icon={faUserCog} /></i>Profile
                                        </Dropdown.Item>

                                        {
                                            canShowQuickStart ?
                                                <Dropdown.Item href="/quick-start"><i>
                                                    <FontAwesomeIcon icon={faRocket} /></i>Quick Start
                                                </Dropdown.Item>
                                                :
                                                ''
                                        }

                                        <Dropdown.Item href={get_document_link("index")} target="_blank">
                                            <i><FontAwesomeIcon icon={faBook} /></i>{QUALDO_DOCUMENTATION}
                                        </Dropdown.Item>
                                        <Dropdown.Item name='logout'
                                            onClick={handleClick.bind(this)}>
                                            <i><FontAwesomeIcon icon={faSignOutAlt} /></i>
                                            Log Out
                                        </Dropdown.Item>
                                    </Dropdown.Menu>
                                </Dropdown>
                            </div>
                        </div>
                    </div>
                </div>
                {/* <Offline polling={false} interval={1000} onChange={this.pageRefresh}>
                <OfflineComponent>
                </OfflineComponent>
            </Offline> */}
            </header>
        </>
    );

}
